import { render, staticRenderFns } from "./dialog-tj-yuyue2.vue?vue&type=template&id=318e2d76&scoped=true"
import script from "./dialog-tj-yuyue2.vue?vue&type=script&lang=js"
export * from "./dialog-tj-yuyue2.vue?vue&type=script&lang=js"
import style0 from "./dialog-tj-yuyue2.vue?vue&type=style&index=0&id=318e2d76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318e2d76",
  null
  
)

export default component.exports